import React, { useState } from 'react';
import { Box, Grid } from '@mui/material';
import { CustomButton } from '../../../../v2/MUI_custom_component';
import DetailsCard from './DetailsCard';
import InlineNomineeForm from './InlineNomineeForm';

const StaffCard = ({ 
    staffData, 
    onDelete,
}) => {
    const { beneficiary, nominee } = staffData;

    const hasValidBeneficiary = beneficiary && Object.keys(beneficiary).length > 0 && beneficiary.full_name;
    const hasValidNominee = nominee && Object.keys(nominee).length > 0 && nominee.full_name;


    // Simplified delete handlers
    const handleDeleteBeneficiary = () => {
        if (onDelete) {
            onDelete('beneficiary');
        }
    };

    const handleDeleteNominee = () => {
        if (onDelete) {
            onDelete('nominee');
        }
    };

    const beneficiaryDetails = hasValidBeneficiary ? [
        { label: 'Name', value: beneficiary.full_name },
        { label: 'D.O.B', value: beneficiary.dob },
        { label: 'Age', value: `${beneficiary.age}y`},
        { label: 'Gender', value: beneficiary.gender },
        { label: 'Mobile No.', value: beneficiary.phone_number },
    ] : [];

    const nomineeDetails = hasValidNominee ? [
        { label: 'Name', value: nominee.full_name },
        { label: 'D.O.B', value: nominee.dob },
        { label: 'Age', value: `${nominee.age}y`},
        { label: 'Gender', value: nominee.gender },
        { label: 'Relation', value: nominee.relation },
        { label: 'Mobile No.', value: nominee.phone_number },
    ] : [];

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
                	<Box sx={{ 
							p: 2, background: '#fff', borderRadius: 2, height: '100%', p: { xs: 2, md: 2 } ,
							display: 'flex',
							flexDirection: 'column',
						}}
					>
                         {hasValidBeneficiary && (
                            <DetailsCard
                                title="Beneficiary Details"
                                isDeletable={beneficiary.is_deletable}
                                onDelete={handleDeleteBeneficiary}
                                details={beneficiaryDetails}
                            />
                        )}
                       {nomineeDetails.length >0 && (
                         <DetailsCard
                            title="Nominee Details"
                            isDeletable={false}
                            onDelete={handleDeleteNominee}
                            details={nomineeDetails}
                         />  
                       )}
                    </Box>
               
            </Grid>    
        </Grid>
    );
};

export default StaffCard;